import React from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
import EmbeddedPage from '../../components/playerEmbeddedPage/components/EmbeddedPage';

const headerTags = {
    title: 'Incorpore Nosso Player', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta: {
        description: 'Antena 1 - Incorpore Nosso Player',
        keywords: 'Antena 1, parceiros, artistas, embedded, embed, noticias, promoção, antena1, radio, rádio, ouvintes,flashback, anos 80, anos 70, música de qualidade, música internacional, musica internacional, musica de qualidade, música boa, programação especial, lounge music, música romântica, musica romantica',
        'og:title': 'Incorpore Nosso Player',
        'og:description': 'Antena 1 - Incorpore Nosso Player',
        'og:image': '',
    },
};

const PlayerEmbeddedPage = () => (
    <div className="pageWrapper">
        <HeaderTags title={headerTags.title} meta={headerTags.meta} />
        <EmbeddedPage />
    </div>
);

export default PlayerEmbeddedPage;
